//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElLottie from '@/components/UI/el-lottie'
import ApplicationFormSection from '~/components/common/section/ApplicationFormSection'

export default {
  name: 'SignupSection',
  components: {
    ApplicationFormSection,
    ElLottie,
  },
  props: {
    crmTags: {
      type: String,
      default: '',
      required: false,
    },
    crmPipeline: {
      type: String,
      default: '',
      required: false,
    },
    crmStatus: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      isThanksMessageActive: false,
      isErrorMessageActive: false,
      signupAnimationFirst: {
        container: '.signup__info-block-el-img--first',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/signup-1.json`,
      },
      signupAnimationSecond: {
        container: '.signup__info-block-el-img--second',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/signup-2.json`,
      },
      // signupAnimationThird: {
      //   container: '.signup__info-block-el-img--third',
      //   renderer: 'svg',
      //   loop: true,
      //   autoplay: true,
      //   animationData: `/${this.$route.path.split('/').pop()}/signup-3.json`,
      // },
      signupAnimationFourth: {
        container: '.signup__img',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/signup-4.json`,
      },
      signupAnimationFive: {
        container: '.signup__form-img',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/signup-5.json`,
      },
    }
  },
  computed: {
    isFrontend() {
      return this.$route.path.split('/').pop() === 'frontend'
    },
  },
  methods: {
    showIcon(routes) {
      return routes.includes(this.$route.path.split('/').pop())
    },
    showThanksMessage() {
      this.isThanksMessageActive = true
    },
    hideThanksMessage() {
      this.isThanksMessageActive = false
    },
    showErrorMessage() {
      this.isErrorMessageActive = true
    },
    hideErrorMessage() {
      this.isErrorMessageActive = false
    },
  },
}
